import logo from "../assets/beatflipz-logo.png";
import { copy } from "../copy";

// The BeatFlipz lockup. The hero keeps the chrome wordmark; this is the mark
// in the nav, footer, and auth.
export default function BrandLogo({ className = "h-9" }: { className?: string }) {
  return <img src={logo} alt={copy.brand} className={`w-auto ${className}`} />;
}
